import { SortingState } from '@tanstack/react-table';

export interface AgentDealUpdateRequestsFilterLocal {
  search?: string;
  applied?: boolean | '';
}

export interface AgentDealUpdateRequestsQueryState {
  skip: number;
  take: number;
  sorting: SortingState;
  filter?: AgentDealUpdateRequestsFilterLocal;
}

export const initialState: AgentDealUpdateRequestsQueryState = {
  skip: 0,
  take: 25,
  sorting: [],
  filter: {
    search: '',
    applied: false,
  },
};

export type AgentDealUpdateRequestsQueryAction =
  | { type: 'SET_PAGINATION'; payload: { skip: number; take: number } }
  | { type: 'SET_SORTING'; payload: SortingState }
  | { type: 'SET_SEARCH'; payload: string }
  | { type: 'SET_FILTERS'; payload: Partial<AgentDealUpdateRequestsFilterLocal> }
  | { type: 'RESET_FILTERS' };

export const queryReducer = (
  state: AgentDealUpdateRequestsQueryState,
  action: AgentDealUpdateRequestsQueryAction,
): AgentDealUpdateRequestsQueryState => {
  switch (action.type) {
    case 'SET_PAGINATION':
      return { ...state, skip: action.payload.skip, take: action.payload.take };
    case 'SET_SORTING':
      return { ...state, sorting: action.payload };
    case 'SET_SEARCH':
      return { ...state, skip: 0, filter: { ...(state.filter || {}), search: action.payload } };
    case 'SET_FILTERS':
      return { ...state, skip: 0, filter: { ...(state.filter || {}), ...action.payload } };
    case 'RESET_FILTERS':
      return { ...state, skip: 0, filter: initialState.filter };
    default:
      return state;
  }
};
